<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
      :style="
        item.url == '/goods_list2'
          ? 'margin-top: 0rem;'
          : 'margin-top: 0.24rem;'
      "
    >
      <!-- <div
        v-if="item.icon1"
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div> -->
      <div class="bgc">
        <img
          :src="item.url === $route.path ? item.sel_img_url : item.img_url"
          alt=""
          :style="
            item.url == '/goods_list2'
              ? 'width: 20.13vw;height: 20.13vw;border-radius: 50%;'
              : ''
          "
        />
      </div>
      <div v-if="item.url !== '/goods_list2'">{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          img_url: require("@assets/images/1-001.png"),
          sel_img_url: require("@assets/images/1-002.png"),
          url: "/"
        },
        // {
        //   name: "会员",
        //   icon1: "icon-shouye-xianxing",
        //   icon2: "icon-shouye",
        //   img_url: require("@assets/images/navi_vip_nor_@2x.png"),
        //   sel_img_url: require("@assets/images/navi_vip_pre_@2x.png"),
        //   url: "/memberCenter"
        // },

        // {
        //   name: "拼团记录",
        //   img: require("@assets/images/navi_me_nor_@2x.png"),
        //   img_sel: require("@assets/images/navi_me_pre_@2x.png"),
        //   url: "/user/teamrecord"
        // },
        {
          name: "签到",
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          img_url: require("@assets/images/2-001.png"),
          sel_img_url: require("@assets/images/2-002.png"),
          url: "/user/sign"
        },
        {
          name: "思邈专区",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          img_url: require("@assets/images/syzq2.png"),
          sel_img_url: require("@assets/images/syzq1.png"),
          url: "/goods_list2"
        },
        {
          name: "购物车",
          icon1: "icon-yingyongchengxu-xianxing",
          icon2: "icon-yingyongchengxu",
          img_url: require("@assets/images/3-001.png"),
          sel_img_url: require("@assets/images/3-002.png"),
          url: "/cart"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          img_url: require("@assets/images/4-001.png"),
          sel_img_url: require("@assets/images/4-002.png"),
          url: "/user"
        }
      ]
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
#footer {
  img {
    width: 6.13vw;
    height: 6.13vw;
  }
}
</style>
